"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerPopover = exports.BmPopover = exports.BmPopoverPlacement = exports.BmPopoverElement = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _popper = _interopRequireDefault(require("popper.js"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<style>\n\t\t\t\t:host([hidden]) {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\n\t\t\t\t:host {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tcontain: content;\n\t\t\t\t}\n\t\t\t</style>\n\t\t\t<slot></slot>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"frame\">\n\t\t\t\t<slot></slot>\n\t\t\t</div>\n\t\t\t<div class=\"arrow-wrapper\">\n\t\t\t\t<div class=\"arrow\"></div>\n\t\t\t</div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host([hidden]) {\n\t\tdisplay: none;\n\t}\n\n\t:host {\n\t\tdisplay: flex;\n\t\tcontain: content;\n\t\tposition: absolute;\n\t\tz-index: 1200;\n\t\tmax-width: 250px;\n\t}\n\n\t.frame {\n\t\tcolor: #212529;\n\t\tfont-family: Arial, 'Helvetica Neue', sans-serif;\n\t\tbackground-color: #fff;\n\t\tborder: 1px solid rgba(0, 0, 0, 0.2);\n\t\tfont-size: 0.875em;\n\t}\n\n\t.arrow {\n\t\tborder: 1px solid rgba(0, 0, 0, 0.2);\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\ttransform: rotate(45deg);\n\t\tbackground-color: white;\n\t\tmargin-top: -9px;\n\t}\n\t.arrow-wrapper {\n\t\tcontain: content;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\theight: 12px;\n\t\tmargin-top: -1px;\n\t\toverflow: hidden;\n\t}\n\n\t:host([x-placement^='top']) {\n\t\tflex-direction: column;\n\t}\n\n\t:host([x-placement^='right']) {\n\t\tflex-direction: row-reverse;\n\t\talign-items: center;\n\t\tjustify-content: space-around;\n\t}\n\t:host([x-placement^='right']) .arrow-wrapper {\n\t\ttransform: rotate(90deg);\n\t}\n\t:host([x-placement^='right']) .frame {\n\t\tmargin-left: -6px;\n\t}\n\n\t:host([x-placement^='bottom']) {\n\t\tflex-direction: column-reverse;\n\t}\n\t:host([x-placement^='bottom']) .arrow-wrapper {\n\t\ttransform: rotate(180deg);\n\t\tmargin-top: 0;\n\t\tmargin-bottom: -1px;\n\t}\n\n\t:host([x-placement^='left']) {\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-around;\n\t}\n\t:host([x-placement^='left']) .arrow-wrapper {\n\t\ttransform: rotate(-90deg);\n\t\tmargin-left: -6px;\n\t}\n\n\t:host([x-placement$='start']) {\n\t\talign-items: flex-start;\n\t}\n\n\t:host([x-placement='top-start']) .arrow-wrapper {\n\t\tmargin-top: -4px;\n\t\tmargin-left: 1px;\n\t}\n\t:host([x-placement='right-start']) .arrow-wrapper {\n\t\tmargin-top: 4px;\n\t}\n\t:host([x-placement='bottom-start']) .frame {\n\t\tmargin-top: -3px;\n\t}\n\t:host([x-placement='bottom-start']) .arrow-wrapper {\n\t\tmargin-left: 1px;\n\t}\n\t:host([x-placement='left-start']) .arrow-wrapper {\n\t\tmargin-top: 4px;\n\t}\n\n\t:host([x-placement$='end']) {\n\t\talign-items: flex-end;\n\t}\n\n\t:host([x-placement='top-end']) .arrow-wrapper {\n\t\tmargin-top: -3px;\n\t\tmargin-right: 1px;\n\t}\n\t:host([x-placement='right-end']) .arrow-wrapper {\n\t\tmargin-bottom: 4px;\n\t}\n\t:host([x-placement='bottom-end']) .arrow-wrapper {\n\t\tmargin-right: 1px;\n\t\tmargin-bottom: -3px;\n\t}\n\t:host([x-placement='left-end']) .arrow-wrapper {\n\t\tmargin-bottom: 4px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmPopoverElement = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmPopoverElement, _BlueElement);

  var _super = (0, _createSuper2.default)(BmPopoverElement);

  function BmPopoverElement() {
    (0, _classCallCheck2.default)(this, BmPopoverElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmPopoverElement, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-popover-element';
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmPopoverElement;
}(_element.BlueElement);

exports.BmPopoverElement = BmPopoverElement;
var BmPopoverPlacement;
exports.BmPopoverPlacement = BmPopoverPlacement;

(function (BmPopoverPlacement) {
  BmPopoverPlacement["Top"] = "top";
  BmPopoverPlacement["Right"] = "right";
  BmPopoverPlacement["Bottom"] = "bottom";
  BmPopoverPlacement["Left"] = "left";
  BmPopoverPlacement["TopEnd"] = "top-end";
  BmPopoverPlacement["RightEnd"] = "right-end";
  BmPopoverPlacement["BottomEnd"] = "bottom-end";
  BmPopoverPlacement["LeftEnd"] = "left-end";
  BmPopoverPlacement["TopStart"] = "top-start";
  BmPopoverPlacement["RightStart"] = "right-start";
  BmPopoverPlacement["BottomStart"] = "bottom-start";
  BmPopoverPlacement["LeftStart"] = "left-start";
})(BmPopoverPlacement || (exports.BmPopoverPlacement = BmPopoverPlacement = {}));

var BmPopover = /*#__PURE__*/function (_BlueElement2) {
  (0, _inherits2.default)(BmPopover, _BlueElement2);

  var _super2 = (0, _createSuper2.default)(BmPopover);

  function BmPopover() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmPopover);
    _this = _super2.call(this);
    _this.placement = BmPopoverPlacement.Top;
    _this.trigger = 'click';
    _this.pop = document.createElement('bm-popover-element');
    _this.popper = void 0;
    _this.onDocumentClick = (0, _bind.default)(_context = _this.onDocumentClick).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmPopover, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmPopover.prototype), "connectedCallback", this).call(this);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('click', this.onClick);
      this.addEventListener('mouseenter', this.onMounseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }
  }, {
    key: "createPopover",
    value: function createPopover() {
      var _this2 = this;

      if (this.popper) {
        return;
      }

      var append = document.body.append || document.body.appendChild;
      append.call(document.body, this.pop);
      requestAnimationFrame(function () {
        _this2.popper = new _popper.default(_this2, _this2.pop, {
          placement: _this2.placement
        });
      });
    }
  }, {
    key: "removePopover",
    value: function removePopover() {
      if (!this.popper) {
        return;
      }

      this.popper.disableEventListeners();
      this.popper.destroy();
      window.document.body.removeChild(this.pop);
      this.popper = undefined;
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmPopover.prototype), "disconnectedCallback", this).call(this);
      window.document.removeEventListener('click', this.onDocumentClick);
      this.removePopover();
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmPopover.prototype), "updated", this).call(this, changedProperties);

      if (changedProperties.has('content') && this.pop && this.content !== changedProperties.get('content')) {
        (0, _element.shadyRender)(this.content, this.pop, {
          scopeName: 'bm-popover-element'
        });
      }

      if (this.popper && changedProperties.has('placement')) {
        this.popper.options.placement = this.placement;
      }

      if (this.popper) {
        this.popper.scheduleUpdate();
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.createPopover();
    }
  }, {
    key: "close",
    value: function close() {
      this.removePopover();
    }
  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(event) {
      if (this.popper) {
        var popover = document.querySelector('bm-popover-element');

        if (popover === null || popover === void 0 ? void 0 : popover.contains(event.target)) {
          return;
        }

        this.close();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (this.trigger !== 'click') {
        return;
      }

      if (this.popper) {
        this.close();
      } else {
        this.open();
      }

      event.stopPropagation();
    }
  }, {
    key: "onMounseEnter",
    value: function onMounseEnter() {
      if (this.trigger === 'mouse') {
        this.open();
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      if (this.trigger === 'mouse') {
        this.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject3());
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-popover';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        placement: {
          type: String,
          attribute: true,
          reflect: true
        },
        content: {
          type: Object,
          attribute: false,
          reflect: false
        },
        trigger: {
          type: String,
          attribute: true,
          reflect: true
        }
      };
    }
  }]);
  return BmPopover;
}(_element.BlueElement);

exports.BmPopover = BmPopover;

var registerPopover = function registerPopover() {
  (0, _element.register)(BmPopoverElement);
  (0, _element.register)(BmPopover);
};

exports.registerPopover = registerPopover;
